import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';

const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
}

function* denuncias() {
  let ULRDestino = "api/denuncias";
  let metodo = "GET";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if( !res.data.success ){
    notification('success', res.data.msg )
  }else{
    yield put({
      type: actions.FORMAT_DENUNCIAS,
      result: res.data.denuncias,
    });
  }
}

function* tramitar(action) {
  let ULRDestino = "api/denuncias/"+action.data.denuncia;
  let metodo = "PUT";
  action.data.tramitador = localStorage.getItem('id_token');
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data:action.data
  });
  if( !res.data.success ){
    notification('success', res.data.msg )
  }else{
    yield put({
      type: actions.GET_DENUNCIAS,
    });
  }
}
export default function* rootSaga() {
  yield all([takeEvery(actions.GET_DENUNCIAS, denuncias)]);
  yield all([takeEvery(actions.EDIT_DENUNCIA, tramitar)]);
}
